const VIRTUAL_CARE_SERVICE = 'virtual care';

/**
 * Returns true iff at least one entry in `specialtyServices`, trimmed and
 * lowercased, exact-matches the literal "virtual care" (never a substring
 * match). Returns false for a non-array input rather than throwing.
 *
 * Matching value and rule mirror `PhysicianBioHero`'s local derivation
 * (`ui.frontend/src/components/PhysicianBioHero/PhysicianBioHero.js`); only
 * the input shape differs — this utility takes the Coveo `string[]` shape
 * directly, with no split step.
 *
 * @param {string[]} specialtyServices
 * @returns {boolean}
 */
const deriveHasVirtualCare = (specialtyServices) => {
    if (!Array.isArray(specialtyServices)) {
        return false;
    }
    return Boolean(
        specialtyServices.some(
            (service) =>
                typeof service === 'string' &&
                service.trim().toLowerCase() === VIRTUAL_CARE_SERVICE,
        ),
    );
};

export default deriveHasVirtualCare;
